import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import User from "./User";
import Model from "./Model";
export class TicketMessage extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'ticket_message_id',
      fieldTitle: 'Ticket message id',
      content: null
    });
    _defineProperty(this, "TicketMessageId", {
      fieldName: 'ticket_message_id',
      fieldTitle: 'Ticket message id',
      content: null
    });
    _defineProperty(this, "TicketMessageUser", {
      fieldName: 'ticket_message_user',
      fieldTitle: 'Ticket message user',
      model: User,
      content: null
    });
    _defineProperty(this, "TicketMessageContent", {
      fieldName: 'ticket_message_content',
      fieldTitle: 'Ticket message content',
      content: null
    });
    _defineProperty(this, "TicketMessageDate", {
      fieldName: 'created_at',
      fieldTitle: 'Ticket message date',
      content: null
    });
  }
  getId() {
    return this.Id.content;
  }
  getDate() {
    return this.TicketMessageDate.content;
  }
  ticketMessageUser() {
    return this.TicketMessageUser.content;
  }
  ticketMessageFullName() {
    let user = this.ticketMessageUser();
    return user instanceof User ? user.getFullName() : null;
  }
  getContent() {
    return this.TicketMessageContent.content;
  }
}
export default TicketMessage;